import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Waypoint } from 'react-waypoint'
import { ScrolledIntoView, EVENTS_LABELS } from 'src/constants/trackingEvents'
import Text from 'src/Components/Text'
import RefiHeading from 'src/Components/RefiHeading'
import YearsInHomeSlider from './YearsInHomeSlider'
import RefiOptionReveal from './RefiOptionReveal'
import { oneTimeTagEventDispatcher } from 'src/helpers/tagManager'

import styles from './RefiByYearsInHome.module.scss'

const propTypes = {
  className: PropTypes.string
}

const scrollIntoView = oneTimeTagEventDispatcher(ScrolledIntoView, {
  eventLabel: EVENTS_LABELS.RefiScenariosSection
})

const RefiByYearsInHome = ({
  className,
  fha,
  isConsolidation,
  refiDetails,
  yearsInHome,
  pmi,
  setRefiOption,
  setYearsInHome,
  locked,
  ...restProps
}) => (
  <div className={classnames(styles.root, className)}>
    <Text color='quiet' align='center' size='s'>
      <FormattedMessage
        id='RefiByYearsInHome.subHeading'
        defaultMessage='Based on current national rate trends:'
      />
    </Text>
    <RefiHeading
      isFha={!!fha}
      isConsolidation={isConsolidation}
      className={styles.heading}
    />
    <Waypoint onEnter={scrollIntoView} bottomOffset='50%'>
      <div />
    </Waypoint>
    <YearsInHomeSlider
      min='1'
      max='30'
      value={yearsInHome}
      onChange={setYearsInHome}
    />
    <RefiOptionReveal
      yearsInHome={yearsInHome}
      pmi={pmi}
      onClickOption={setRefiOption}
      options={refiDetails}
      locked={locked}
    />
  </div>
)

RefiByYearsInHome.propTypes = propTypes

export default RefiByYearsInHome
